var galleryThumbs = new Swiper('.gallery-thumbs', {
  effect: 'coverflow',
  grabCursor: true,
  centeredSlides: true,
clickable: true,
  slidesPerView: '2',  
  coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 50,
        modifier: 6,
        slideShadows : false,
    }, 
thumbs: {
    swiper: galleryThumbs
    }   
  });

  
var galleryTop = new Swiper('.swiper-container.testimonial', {
  // speed: 800,
  // spaceBetween: 10,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  direction: 'vertical',
  pagination: {
    clickable: true,
    el: '.swiper-pagination',
    type: 'bullets',
  },
  thumbs: {
    swiper: galleryThumbs
    }
  });


// hide and show css
// $('.tab-content').hide();
// $('#tab-1').show();

// $('#select-box').change(function () {
//    dropdown = $('#select-box').val();
//   $('.tab-content').hide();
//   $('#' + "tab-" + dropdown).show();                                    
// });


// On scroll Text visiable
// $(window).scroll(function() {
//     if ($(this).scrollTop()>620)
//      {
//         $('p.setria-pure-para span.setria-scroll').css({"color": "#000000", "transition": "1s"});
//      }
//     else
//      {
//       $('p.setria-pure-para span.setria-scroll').css({"color": "#A5A5A5", "transition": "1s"});
//      }
//  });



// about page on scroll
// $(window).scroll(function() {
//     if ($(this).scrollTop()>20)
//      {
//         $('.about-banner-inner-titl1').css({"position": "relative", "display": "none"});
//      }
//     else
//      {
//       $('.about-banner-inner-titl1').css({"position": "fixed", "top": "400px"});
//      }
//  });


// Accordian 
// const items = document.querySelectorAll(".accordion button");

// function toggleAccordion() {
//   const itemToggle = this.getAttribute('aria-expanded');
  
//   for (i = 0; i < items.length; i++) {
//     items[i].setAttribute('aria-expanded', 'false');
//   }
  
//   if (itemToggle == 'false') {
//     this.setAttribute('aria-expanded', 'true');
//   }
// }

// items.forEach(item => item.addEventListener('click', toggleAccordion));



// Scroll Timeline start 
// $(window).on('scroll', function(){
//   function isScrollIntoView(elem, index) {
//     var docViewTop = $(window).scrollTop();
//     var docViewBottom = docViewTop + $(window).height();
//     var elemTop = $(elem).offset().top;
//     var elemBottom = elemTop + $(window).height()*.5;
//     if(elemBottom <= docViewBottom && elemTop >= docViewTop) {
//       $(elem).addClass('active');
//     }
//     if(!(elemBottom <= docViewBottom)) {
//       $(elem).removeClass('active');
//     }
//     var MainTimelineContainer = $('#vertical-scrollable-timeline')[0];
//     var MainTimelineContainerBottom = MainTimelineContainer.getBoundingClientRect().bottom - $(window).height()*.5;
//     $(MainTimelineContainer).find('.inner').css('height',MainTimelineContainerBottom+'px');
//   }
//   var timeline = $('#vertical-scrollable-timeline li');
//   Array.from(timeline).forEach(isScrollIntoView);
// });


// Test Scroll
// var div_top = $('h2.setria-video-titl1.about-us-fixed').offset().top;

// $(window).scroll(function() {
//     var window_top = $(window).scrollTop() - 50;
//     if (window_top > div_top) {
//         if (!$('h2.setria-video-titl1.about-us-fixed').is('.sticky')) {
//             $('h2.setria-video-titl1.about-us-fixed').addClass('sticky');
//         }
//     } else {
//         $('h2.setria-video-titl1.about-us-fixed').removeClass('sticky');
//     }
// });

// second show
// var div_top = $('h2.setria-video-titl1.about-us.show1').offset().top;

// $(window).scroll(function() {
//     var window_top = $(window).scrollTop() - 50;
//     if (window_top > div_top) {
//         if (!$('h2.setria-video-titl1.about-us.show1').is('.visiable')) {
//             $('h2.setria-video-titl1.about-us.show1').addClass('visiable');
//         }
//     } else {
//         $('h2.setria-video-titl1.about-us.show1').removeClass('visiable');
//     }
// });







// $(window).scroll(function(){
//     if ($(this).scrollTop() > 50) {
//        $('h2.setria-video-titl1.about-us-fixed').addClass('sticky');
//     } else {
//        $('h2.setria-video-titl1.about-us-fixed').removeClass('sticky');
//     }
// });
// $(window).scroll(function(){
//     if ($(this).scrollTop() > 50) {
//        $('h2.setria-video-titl1.about-us-fixed').addClass('visiable');
//     } else {
//        $('h2.setria-video-titl1.about-us-fixed').removeClass('visiable');
//     }
// });